import Vue from "vue";
import VueRouter from "vue-router";
Vue.use(VueRouter);

const routes = [{
    path: "/",
    name: "",
    component: () =>
        import ("../views/Index.vue"),
    meta: {
        title: "在线黄历查询,2024结婚搬家吉日,黄历查询2024,择吉老黄历,今日黄历查询",
        content: {
            keywords: '老黄历,佛历,道历,儒略日,星宿歌诀,九星歌诀,智能排盘,中国万年历黄道吉日,今日黄历查询,在线黄历查询,万年历吉日,中国黄历,结婚搬家黄历查询',
            description: ''
        }
    }
}, {
    path: "/fo",
    name: "fo",
    component: () =>
        import ("../views/Fo.vue"),
    meta: {
        title: "佛历2024年,2024年佛教节日大全,2024佛教日历节日在线查询",
        content: {
            keywords: '佛历万年历,佛教日历查询,2024年佛历全年表,佛教日历,今日佛历查询',
            description: ''
        }
    }
}, {
    path: "/dao",
    name: "dao",
    component: () =>
        import ("../views/Dao.vue"),
    meta: {
        title: "道历2024年,2024年道历节日大全,2024道教日历节日在线查询",
        content: {
            keywords: '道历万年历,道教日历查询,2024年道历全年表,道教日历,今日道历查询',
            description: ''
        }
    }
}, {
    path: "/yi",
    name: "yi",
    component: () =>
        import ("../views/Yi.vue"),
    meta: {
        title: "每月每日宜忌在线查询",
        content: {
            keywords: '每月每日宜忌在线查询',
            description: '当月有哪些日子是吉日，本网提供每日吉日在线查询！'
        }
    }
}, {
    path: "/yi/:id",
    name: "yi",
    component: () =>
        import ("../views/Yi.vue"),
    meta: {
        title: "每月每日宜忌在线查询",
        content: {
            keywords: '每月每日宜忌在线查询',
            description: '当月有哪些日子是吉日，本网提供吉日在线查询！'
        }
    },
    type: '-1'
}, {
    path: "/ji",
    name: "ji",
    component: () =>
        import ("../views/Ji.vue"),
    meta: {
        title: "每月每日宜忌在线查询",
        content: {
            keywords: '每月每日宜忌在线查询',
            description: '当月有哪些日子是忌日，本网提供忌日在线查询！'
        }
    }
}, {
    path: "/ji/:id",
    name: "ji",
    component: () =>
        import ("../views/Ji.vue"),
    meta: {
        title: "每月每日宜忌在线查询",
        content: {
            keywords: '每月每日宜忌在线查询',
            description: '当月有哪些日子是忌日，本网提供吉忌日在线查询！'
        }
    },
    type: '-1'
}, {
    path: "/xingzuo",
    name: "xingzuo",
    component: () =>
        import ("../views/XZA.vue"),
    meta: {
        title: "十二星座最新日期对照表,12星座性格特征分析",
        content: {
            keywords: '十二星座最新日期对照表,12星座性格特征分析,星座查询,星座运势',
            description: '本网为大家提供十二星座最新日期对照表，12星座性格特征分析等相关信息！'
        }
    }
}, {
    path: "/xingzuo/:id",
    name: "xingzuo",
    component: () =>
        import ("../views/XZ.vue"),
    meta: {
        title: "十二星座最新日期对照表,12星座性格特征分析",
        content: {
            keywords: '十二星座最新日期对照表,12星座性格特征分析,星座查询,星座运势',
            description: '本网为大家提供十二星座最新日期对照表，12星座性格特征分析等相关信息！'
        }
    }
}, {
    path: "/name",
    name: "name",
    component: () =>
        import ("../views/Name.vue"),
    meta: {
        title: "八字取名,免费生辰八字取名字",
        content: {
            keywords: '八字取名,免费生辰八字取名字,生辰八字起名,宝宝取名字,免费周易起名字大全,五行相生命名法,宝宝生辰八字起名',
            description: '本网为大家提供免费生辰八字取名字、男宝宝取名、女宝宝八字取名、周易起名字大全等相关功能！'
        }
    }
}, {
    path: "/name/:id",
    name: "name",
    component: () =>
        import ("../views/Name.vue"),
    meta: {
        title: "八字取名,免费生辰八字取名字",
        content: {
            keywords: '八字取名,免费生辰八字取名字,生辰八字起名,宝宝取名字,免费周易起名字大全,五行相生命名法,宝宝生辰八字起名',
            description: '本网为大家提供免费生辰八字取名字、男宝宝取名、女宝宝八字取名、周易起名字大全等相关功能！'
        }
    }
}, {
    path: "/baike",
    name: "baike",
    component: () =>
        import ("../views/Baike.vue"),
    meta: {
        title: "节日百科,中国节日,道家节日,佛教节日",
        content: {
            keywords: '节日百科,中国节日,道家节日,佛教节日',
            description: '中华老黄历为大家提供免费节日百科、中国节日、道家节日、佛教节日等相关信息！'
        }
    }
}, {
    path: "/baike/:id",
    name: "baike",
    component: () =>
        import ("../views/Baike.vue"),
    meta: {
        title: "节日百科,中国节日,道家节日,佛教节日",
        content: {
            keywords: '节日百科,中国节日,道家节日,佛教节日',
            description: '中华老黄历为大家提供免费节日百科、中国节日、道家节日、佛教节日等相关信息！'
        }
    }
}, {
    path: "/jiemeng",
    name: "jiemeng",
    component: () =>
        import ("../views/JieMeng.vue"),
    meta: {
        title: "周公解梦,免费周公在线解梦",
        content: {
            keywords: '周公解梦,免费周公在线解梦,周公解梦大全查询',
            description: '中华老黄历为大家提供周公解梦、免费周公在线解梦、周公解梦大全查询等相关信息！'
        }
    }
}, {
    path: "/jiemeng/:id",
    name: "jiemeng",
    component: () =>
        import ("../views/JieMeng.vue"),
    meta: {
        title: "周公解梦,免费周公在线解梦",
        content: {
            keywords: '周公解梦,免费周公在线解梦,周公解梦大全查询',
            description: '中华老黄历为大家提供周公解梦、免费周公在线解梦、周公解梦大全查询等相关信息！'
        }
    }
}];

const router = new VueRouter({
    mode: "history",
    base: process.env.BASE_URL,
    routes,
    // 预渲染
    mounted() {
        document.dispatchEvent(new Event('render-event'))
    }
});

export default router;


// WEBPACK FOOTER //
// ./src/router/index.js